<template>
  <div id="app">

    <router-view />
   
  </div>
</template>
<script>

export default {
  data() {
    return {
   
    }
  },
  methods: {
 
  },
  created() {
  }

}
</script>
<style scoped>

</style>